// extracted by mini-css-extract-plugin
export default {"container":"BillPageLayout_container__cBfps","titleContainer":"BillPageLayout_titleContainer__Fi7-T","title":"BillPageLayout_title__osfWC","content":"BillPageLayout_content__B52nE"};